import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';

const Imprint = () => {
  const companyDetails = {
    name: 'OLBMI LIMITED',
    address: 'Mnasiadou, 10, 2nd Floor, 1065, Nicosia, Cyprus',
    email: 'support@learnaihub.net',
    director: 'Theodora Kyriakou',
    registrationNumber: 'HE489301',
    taxNumber: '60346740F',
    vatNumber: 'CY60346740F',
  };

  const sections = [
    {
      id: '1',
      title: 'Company Information',
      items: [
        { label: 'Company Name', value: companyDetails.name },
        { label: 'Registered Address', value: companyDetails.address },
        { label: 'Represented by / Director', value: companyDetails.director },
      ],
    },
    {
      id: '2',
      title: 'Registration and Tax Information',
      items: [
        { label: 'Company Registration Number', value: companyDetails.registrationNumber },
        { label: 'Tax Identification Number', value: companyDetails.taxNumber },
        { label: 'VAT Identification Number', value: companyDetails.vatNumber },
      ],
    },
  ];

  return (
    <>
      <Header />

      {/* Page Background */}
      <div className="bg-[#f8f9fa] min-h-screen font-sans pt-24 pb-16">

        {/* Main Content Container */}
        <main className="max-w-4xl mx-auto px-6">

          {/* White Card */}
          <div className="bg-white rounded-[2rem] shadow-sm border border-zinc-100 p-8 md:p-14 mb-16">

            {/* Header Section */}
            <div className="mb-10">
              <h1 className="text-4xl md:text-5xl font-black text-[#042b1f] tracking-tight mb-4">
                Imprint
              </h1>
              <div className="h-1.5 w-12 bg-amber-400 rounded-full mb-8"></div>
              <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                This page provides the legal disclosure information for this website.
              </p>
            </div>

            {/* Sections with info tables */}
            <div className="space-y-10">

              {sections.map((section) => (
                <div key={section.id} className="space-y-4">
                  <h2 className="text-xl font-bold text-[#042b1f]">{section.title}</h2>
                  <div className="bg-zinc-50 border border-zinc-100 rounded-2xl overflow-hidden">
                    {section.items.map((item, index) => (
                      <div
                        key={index}
                        className={`flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 px-6 py-4 ${
                          index < section.items.length - 1 ? 'border-b border-zinc-100' : ''
                        }`}
                      >
                        <span className="text-xs sm:text-sm font-bold text-[#042b1f] sm:w-56 shrink-0">
                          {item.label}
                        </span>
                        <span className="text-zinc-600 text-sm md:text-base font-medium">{item.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              {/* Contact */}
              <div className="space-y-4">
                <h2 className="text-xl font-bold text-[#042b1f]">Contact</h2>
                <div className="bg-zinc-50 border border-zinc-100 rounded-2xl px-6 py-4">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                    <span className="text-xs sm:text-sm font-bold text-[#042b1f] sm:w-56 shrink-0">Email</span>
                    <a
                      href={`mailto:${companyDetails.email}`}
                      className="text-amber-600 hover:text-amber-700 font-medium text-sm md:text-base transition-colors"
                    >
                      {companyDetails.email}
                    </a>
                  </div>
                </div>
              </div>

              {/* Responsible for Website Content */}
              <div className="space-y-4">
                <h2 className="text-xl font-bold text-[#042b1f]">Responsible for Website Content</h2>
                <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                  {companyDetails.name}<br />
                  Mnasiadou, 10, 2nd Floor<br />
                  1065, Nicosia<br />
                  Cyprus
                </p>
              </div>

              {/* Disclaimer */}
              <div className="space-y-4">
                <h2 className="text-xl font-bold text-[#042b1f]">Disclaimer</h2>
                <div className="bg-zinc-50 border border-zinc-100 rounded-2xl p-6 space-y-4">
                  <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                    The information provided on this website is for general informational purposes only.
                    While we make every effort to keep the content accurate and up to date, we do not
                    accept liability for any errors, omissions, or outdated information.
                  </p>
                  <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-medium">
                    This imprint is provided for transparency and legal disclosure purposes. For any
                    questions regarding the website or company information, please contact us using the
                    email address listed above.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default Imprint;
